import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgTruckIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m16 8.38-2.504-2.86H12.43V1.2H0v11.77h1.546a2.35 2.35 0 0 0 2.344 2.35 2.35 2.35 0 0 0 2.344-2.35h2.813a2.35 2.35 0 0 0 2.345 2.35 2.35 2.35 0 0 0 2.344-2.35c0-.08-.02-.16-.02-.25h2.264V8.38H16ZM4.997 12.97c0 .61-.498 1.1-1.097 1.1-.598 0-1.097-.5-1.097-1.1 0-.61.489-1.1 1.097-1.1.609 0 1.097.5 1.097 1.1Zm4.43-1.25H5.874a2.346 2.346 0 0 0-1.985-1.1c-.838 0-1.566.44-1.985 1.1h-.668V2.45h9.935v8.19c-.728.08-1.367.48-1.746 1.08Zm1.975 2.36c-.609 0-1.098-.5-1.098-1.1 0-.61.499-1.1 1.098-1.1.518 0 .937.37 1.047.86.02.08.05.16.05.25.01.59-.489 1.09-1.098 1.09Zm3.351-2.6h-1.546c-.21-.25-.469-.46-.768-.61v-4.1h.489l1.825 2.08v2.63Z",
    fill: "currentColor"
  }));
}

export { SvgTruckIcon as default };
